import {
  filterByPropertyValues
} from 'utilities/collection';

import operators from './operators';

export function getOperatorsByFieldType(operators, fieldType) {

  const filteredOperators = [];

  for (let operator of operators) {

    if (operator.supportedTypes.indexOf(fieldType) === -1) {
      continue;
    }

    filteredOperators.push(operator);

  }

  return filteredOperators;

}

function getOperatorsByFieldOperator(operators, expectedOperators) {

  if (Array.isArray(expectedOperators) === false) {
    return operators;
  }

  const filteredOperators = filterByPropertyValues(operators, 'key', expectedOperators);

  return filteredOperators;

}

export function getOperatorsByField(field) {

  return getOperatorsByFieldType(getOperatorsByFieldOperator(operators, field.operators), field.type);

}

export function cloneOperator(operator) {

  const clone = {
    label: operator.label,
    key: operator.key,
    supportedTypes: [...operator.supportedTypes || []],
    supportedInputType: operator.supportedInputType
  };

  return clone;

}